/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ReactionTypeEnum } from '../models/ReactionTypeEnum';
import { HttpFile } from '../http/http';

export class CommentReactionRequest {
    'comment': number;
    'type': ReactionTypeEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "comment",
            "baseName": "comment",
            "type": "number",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "ReactionTypeEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return CommentReactionRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



